var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jsapi-pay"},[(_vm.loading)?_c('div',{staticClass:"jsapi-pay__loading"},[_vm._v("正在唤起微信支付...")]):_vm._e(),(_vm.error)?_c('div',{staticClass:"jsapi-pay__error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }